import DateBox from 'devextreme-react/date-box';

import DateTimeUtils from '../../common/utils/DateTimeUtils'

import { DateViewMode } from '../../common/value-types/DateViewMode';

export default function ScheduleDateView(props) {
  return (
    <DateBox
      acceptCustomValue={false}
      calendarOptions={{ maxZoomLevel: 'year', minZoomLevel: 'century' }}
      displayFormat={
        value => props.dateViewMode === DateViewMode.fullMonth
          ? DateTimeUtils.formatMonthAndYear(value, props.locale)
          : DateTimeUtils.formatMonthDateAndYear(value, props.locale)
      }
      disabled={props.disabled}
      format="date"
      readOnly={props.dateViewMode !== DateViewMode.fullMonth}
      ref={props.innerRef}
      onValueChanged={props.onCurrentMonthChanged}
      value={
        props.dateViewMode === DateViewMode.fullMonth
          ? props.currentMonth
          : props.currentDate
      }
    />
  );
}